function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var scroller = new (/*#__PURE__*/function () {
  function Scroller() {
    var _this = this;
    _classCallCheck(this, Scroller);
    document.addEventDelegate('APP:READY', function (_) {
      _this.init();
    });
  }
  return _createClass(Scroller, [{
    key: "init",
    value: function init() {
      if (window.IntersectionObserver) {
        var sectionObserver = new IntersectionObserver(function (entries) {
          var current = null;
          entries.forEach(function (entry) {
            if (!current && entry.target.id && entry.isIntersecting && entry.intersectionRatio > 0) {
              current = document.querySelector('#main-nav a[data-href="#' + entry.target.id + '"]');
            }
            if (entry.intersectionRatio > 0) {
              entry.target.classList.add('is-in-viewport');
            } else {
              if (!entry.target.classList.contains('is-in-viewport')) {
                entry.target.classList.add('is-waiting-viewport');
              }
            }
          });
          if (current) {
            document.dispatchEventDelegate('NAV:ACTIVE_ITEM', {
              current: current
            });
          }
        }, {
          threshold: 0.25
        });
        document.querySelectorAll('[data-section]').forEach(function (section) {
          sectionObserver.observe(section);
        });
      }
    }
  }]);
}())();